import React, { Component } from 'react';
import './animations.css';

export default class Modal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			is_open_modal: this.props.is_show
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.is_show != this.state.is_open_modal) {
			setTimeout(() => { this.setState({ is_open_modal: nextProps.is_show, }) }, 600);
		}
		return true;
	}

	render() {
		let style = {
			display: this.state.is_open_modal ? 'block' : 'none',
		}

		let back_drop_style = {
			width: '100%',
			height: this.props.height,
			position: 'fixed',
			zIndex: '100',
			left: 0,
			top: 0,
			backgroundColor: 'rgba(0, 0, 0, 0.5)',
		}

		let modal_style = {
			// 2px for border
			width: this.props.width != null ? this.props.width - 2 : '80%',
			height: this.props.height - 2,
			position: 'fixed',
			left: 0,
			top: 0,
			zIndex: '500',
			backgroundColor: 'white',
			border: '1px solid #ccc',
			overflowY: 'auto'
		}

		return (
			<div style={style}  >
				<div style={back_drop_style} onClick={this.props.handleToggle}></div>
				<div style={modal_style} className={this.props.is_show ? 'slideInLeft' : 'slideOutLeft'}>
					{this.props.children}
				</div>
			</div>
		)
	}
}